import { Reveal } from "./Reveal";

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`font-mono-x text-xs uppercase tracking-[0.28em] text-gold ${className}`}>{children}</span>
);

export const SectionHeading = ({ eyebrow, title, subtitle, center = false, light = true }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className={`mt-3 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${light ? "text-[#0B132B]" : "text-[#0B132B]"}`}>
      {title}
    </h2>
    {subtitle && <p className="mt-4 text-base leading-relaxed text-slate-500">{subtitle}</p>}
    <div className={`mt-6 h-px w-24 gold-line ${center ? "mx-auto" : ""}`} />
  </div>
);

export const PageHero = ({ eyebrow, title, subtitle, image, children }) => (
  <section className="relative overflow-hidden border-b border-slate-200">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 hero-scrim" />
      </div>
    )}
    <div className="absolute inset-0 grid-texture opacity-40" />
    <div className="relative mx-auto max-w-7xl px-4 py-24 lg:px-8 lg:py-32">
      <Reveal>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <h1 className="mt-4 max-w-4xl font-display text-4xl font-extrabold leading-tight tracking-tight text-[#0B132B] sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {subtitle && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-600">{subtitle}</p>}
        {children && <div className="mt-8">{children}</div>}
      </Reveal>
    </div>
  </section>
);
